// src/SignIn.js
import React, { useEffect, useState } from 'react';
import { auth, provider } from './firebase-config';
import { signInWithPopup, onAuthStateChanged, signOut } from "firebase/auth";
import './SignIn.css';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { v4 as uuidv4 } from 'uuid'; // Import uuid

const SignIn = (props) => {
    const baseURL = props.baseURL;
    const [user, setUser] = useState(null);
    const [menuOpen, setMenuOpen] = useState(false);
    let navigate = useNavigate();
    const [userEmail, setUserEmail] = useState(undefined);

    const registerUser = async (userId, email) => {
        try {
          const userURL = `${baseURL}/api/v1/register_user`;
          const params = new URLSearchParams({
            email: email,
            user_id: userId,
          });
          const URL = `${userURL}?${params.toString()}`;
          const response = await fetch(URL, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ user_id: userId, email: email }),
          });
    
          if (!response.ok) {
            if (response.status === 409) { // Assuming 409 is used for "Conflict" indicating user already exists
              console.log(`User with ID ${userId} already exists.`);
              return;
            } else {
              throw new Error(`Error ${response.status}: ${response.statusText}`);
            }
          }
          const data = await response.json();
          console.log('User registered successfully:', data);
        } catch (error) {
          console.error('Error registering user:', error);
        }
      };

    useEffect(() => {
        console.log("----- enter SignIn")
        const unsubscribe = auth.onAuthStateChanged(user => {
          if (user) {
            setUser(user);
            const newUserId = user.uid;
            props.setUserId(newUserId);
            setUserEmail(user.email);
            console.log('Set userId from Firebase:', newUserId);
            console.log('Logged in as:', user.email);
            // Register user with the API server
            registerUser(newUserId, user.email);
            Cookies.set('userId', newUserId, { expires: 365 }); // Set cookie to expire in 365 days
          } else {
            const cookieUserId = Cookies.get('userId');
            if (cookieUserId) {
              props.setUserId(cookieUserId);
              console.log('Using userId from cookie:', cookieUserId);
            } else {
              const newUserId = uuidv4(); // Generate a random UUID
              Cookies.set('userId', newUserId, { expires: 365 }); // Set cookie to expire in 365 days
              props.setUserId(newUserId);
              console.log('Generated new userId:', newUserId);
            }
            setUserEmail(undefined);
          }
        });
    
        return () => {
          unsubscribe();
          console.log("------exit SignIn");
        }
      }, []);

    const signInWithGoogle = async () => {
        try {
            await signInWithPopup(auth, provider);
        } catch (error) {
            console.error(error);
        }
    };

    const handleSignOut = async () => {
        setUser(null);
        props.setUserId(null);
        navigate('/');
        try {
            await signOut(auth);
        } catch (error) {
            console.error(error);
        }
    };

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    return (
        <div className="sign-in-container">
            {user ? (
                <div className="sign-in-icon-hover-button-container">
                    <button className="sign-in-icon-hover-button" onClick={toggleMenu}>
                        <img className="sign-in-avatar-icon" src={user.photoURL} alt="avatar" />
                        <span className="sign-in-avatar-icon-text">{user.displayName}</span>
                    </button>
                    {menuOpen && (
                        <div className="sign-in-icon-hover-button-container">
                            <button className="logout-button"  onClick={handleSignOut}>
                                <LogoutIcon className="logout-icon" />
                                Logout
                            </button>
                        </div>
                    )}
                </div>
            ) : (
                <button className="sign-in-button" onClick={signInWithGoogle}>
                    Sign In
                </button>
            )}
        </div>
    );
};

const SignInIcon = (props) => {
    const [user, setUser] = useState(null);
    const baseURL = props.baseURL;
    const [menuOpen, setMenuOpen] = useState(false);
    const [userEmail, setUserEmail] = useState(undefined);
    let navigate = useNavigate();

    const registerUser = async (userId, email) => {
        try {
          const userURL = `${baseURL}/api/v1/register_user`;
          const params = new URLSearchParams({
            email: email,
            user_id: userId,
          });
          const URL = `${userURL}?${params.toString()}`;
          const response = await fetch(URL, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ user_id: userId, email: email }),
          });
    
          if (!response.ok) {
            if (response.status === 409) { // Assuming 409 is used for "Conflict" indicating user already exists
              console.log(`User with ID ${userId} already exists.`);
              return;
            } else {
              throw new Error(`Error ${response.status}: ${response.statusText}`);
            }
          }
          const data = await response.json();
          console.log('User registered successfully:', data);
        } catch (error) {
          console.error('Error registering user:', error);
        }
      };

    useEffect(() => {
        console.log("----- enter SignIn")
        const unsubscribe = auth.onAuthStateChanged(user => {
        if (user) {
            setUser(user);
            const newUserId = user.uid;
            props.setUserId(newUserId);
            setUserEmail(user.email);
            console.log('Set userId from Firebase:', newUserId);
            console.log('Logged in as:', user.email);
            // Register user with the API server
            registerUser(newUserId, user.email);
            Cookies.set('userId', newUserId, { expires: 365 }); // Set cookie to expire in 365 days
        } else {
            const cookieUserId = Cookies.get('userId');
            if (cookieUserId) {
                props.setUserId(cookieUserId);
                console.log('Using userId from cookie:', cookieUserId);
            } else {
                const newUserId = uuidv4(); // Generate a random UUID
                Cookies.set('userId', newUserId, { expires: 365 }); // Set cookie to expire in 365 days
                props.setUserId(newUserId);
                console.log('Generated new userId:', newUserId);
            }
            setUserEmail(undefined);
        }
    });

    return () => {
        unsubscribe();
        console.log("------exit SignIn");
    }
    }, []);

    const signInWithGoogle = async () => {
        try {
            await signInWithPopup(auth, provider);
        } catch (error) {
            console.error(error);
        }
    };

    const handleSignOut = async () => {
        setUser(null);
        props.setUserId(null);
        navigate('/');
        try {
            await signOut(auth);
        } catch (error) {
            console.error(error);
        }
    };

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    return (
        <div className="sign-in-icon-collapse-container">
            {user ? (
                <div className="sign-in-icon-collapse-container" >
                    <button className="sign-in-icon-collapse" onClick={toggleMenu}>
                            <img className="sign-in-avatar-icon" src={user.photoURL}/>
                    </button>
                    {menuOpen && (
                        <div className="sign-in-icon-collapse-container">
                            <button className="sign-in-icon-collapse" onClick={handleSignOut}>
                                <LogoutIcon className="sign-out-icon" />
                            </button>
                        </div>
                    )}
                </div>
            ) : (
                <button className="sign-in-icon-collapse" onClick={signInWithGoogle}>
                    <LoginIcon className="sign-out-icon" />
                </button>


            
                )
            }
        </div>
    );
};

export { SignIn, SignInIcon };
